import { CartItem, CustomCartItem, EventNames } from "./customEvents";

const win = (window as any);

function init() {
  const cart = win.ARI.PartStream.Cart;

  if (!cart) {
    console.error('Partstream was initialized but cart API was not found');
    return;
  }

  cart.JSAddToCart = (h: any) => {

    let callbackIds: string[] = [];
    const artnr = h.find('input[name="arisku"]')?.attr('value');
    const noi = +h.find('input[name="ariqty"]')?.attr('value');

    if (!artnr || !noi) {
      console.error('Could not add Partstream article to Primeflow because article number was missing or quantity was 0.');
      return;
    };

    let pa = document.querySelector('#ariPartList [name="' + artnr + '"]')?.parentNode as any;

    if (!pa) {
      pa = document.querySelector('#ariSearchResultsPartList [name="' + artnr + '"]')?.parentNode;

      if (!pa) {
        console.error('Could not get parent node.');
        return;
      }
    }

    const handleCartCallback = (event: any) => {

      if (event.detail.error) {
        if (callbackIds.includes(event.detail.callback_id)) {
        	console.error('Could not add custom cart item to Primeflow.');
        	window.removeEventListener(EventNames.cartCallback, handleCartCallback);
          return;
        }

        const price = pa.attributes['adjustedprice'].value.replace(/[^\d,\.]/g, '').replace(',', '.');
        const title = pa.querySelector('.ariPLDesc').innerText;
        const customCartItem: CustomCartItem = {
        	code: artnr,
        	name: title,
        	price: Math.round(+price * 100),
        	quantity: noi,
        	callback_id: Math.random().toString(16).substring(2)
        };

        callbackIds.push(customCartItem.callback_id);
        window.dispatchEvent(new CustomEvent(EventNames.cartAddCustom, { detail: customCartItem }));
        return;
      }

      window.dispatchEvent(new CustomEvent(EventNames.cartOpen));
    	window.removeEventListener(EventNames.cartCallback, handleCartCallback);
    };

    const cartItem: CartItem = {
      sku: artnr,
      quantity: noi,
      callback_id: Math.random().toString(16).substring(2)
    };

    window.dispatchEvent(new CustomEvent(EventNames.cartAdd, { detail: cartItem }));
    window.addEventListener(EventNames.cartCallback, handleCartCallback);
  };
}

export default function Partstream() {
  if (win.ARI.PartStream.Cart.JSAddToCart || typeof win.arijQuery === 'function') {
    init();
    return;
  }

  console.error('Could not initialize Primeflow logic upon Partstream');
}